var map = {
	"./connect-store-reward.svg": 570719,
	"./create-aluminum-print-reward.svg": 452670,
	"./create-athletic-crop-top-reward.svg": 174513,
	"./create-baby-youth-leggings-reward.svg": 7943,
	"./create-beanie-reward.svg": 152722,
	"./create-blanket-reward.svg": 128277,
	"./create-book-reward.svg": 665791,
	"./create-canvas-reward.svg": 281114,
	"./create-coaster-reward.svg": 71171,
	"./create-crewneck-sweatshirt-reward.svg": 945307,
	"./create-dad-cap-with-printed-patch-reward.svg": 160389,
	"./create-day-tote-reward.svg": 23829,
	"./create-desk-mat-reward.svg": 260288,
	"./create-drawstring-bag-reward.svg": 631602,
	"./create-dress-reward.svg": 681545,
	"./create-duvet-cover-reward.svg": 458698,
	"./create-fabric-reward.svg": 659659,
	"./create-fitted-polo-shirt-reward.svg": 905256,
	"./create-headband-reward.svg": 377315,
	"./create-kimono-reward.svg": 749845,
	"./create-leggings-reward.svg": 311234,
	"./create-makeup-bag-reward.svg": 689518,
	"./create-men-underwear-reward.svg": 89202,
	"./create-origami-tote-reward.svg": 303909,
	"./create-permanent-sticker-reward.svg": 645878,
	"./create-pet-bowl-reward.svg": 292674,
	"./create-pillow-case-reward.svg": 140174,
	"./create-placemat-reward.svg": 763557,
	"./create-premium-drawstring-bag-reward.svg": 115214,
	"./create-printed-patch-reward.svg": 783687,
	"./create-racerback-tank-top-reward.svg": 32485,
	"./create-ruffle-scrunchie-reward.svg": 152379,
	"./create-scarf-reward.svg": 429451,
	"./create-scarf-reward_inactive.svg": 363865,
	"./create-scoop-bralette-reward.svg": 925338,
	"./create-shirt-bellacanvas-3001-reward.svg": 13914,
	"./create-shirt-bellacanvas-3001-reward_inactive.svg": 371738,
	"./create-shorts-reward.svg": 593673,
	"./create-skirt-reward.svg": 860497,
	"./create-snapback-with-printed-patch-reward.svg": 964244,
	"./create-stainless-steel-tumbler-reward.svg": 280258,
	"./create-stainless-steel-water-bottle-reward.svg": 683221,
	"./create-stationery-card-reward.svg": 257849,
	"./create-tablecloth-reward.svg": 808238,
	"./create-tank-top-reward.svg": 847088,
	"./create-tea-towel-reward.svg": 828338,
	"./create-tote-bag-reward.svg": 357927,
	"./create-twilly-scarf-reward.svg": 713877,
	"./create-twilly-scarf-reward_inactive.svg": 841719,
	"./create-unisex-joggers-reward.svg": 358022,
	"./create-unisex-polo-shirt-reward.svg": 540034,
	"./create-vegan-leather-backpack-reward.svg": 890180,
	"./create-vegan-leather-crossbody-purse-reward.svg": 173496,
	"./create-vegan-leather-makeup-bag-reward.svg": 233602,
	"./create-vegan-leather-placemat-reward.svg": 143457,
	"./create-vegan-leather-tote-bag-reward.svg": 783507,
	"./create-wall-tapestry-reward.svg": 202747,
	"./create-women-underwear-reward.svg": 857788,
	"./create-wrap-skirt-reward.svg": 456768,
	"./create-yoga-shorts-reward.svg": 784578,
	"./create-zipper-carry-all-reward.svg": 712080,
	"./sell-product-one-reward.svg": 456752,
	"./sell-product-ten-reward.svg": 675343,
	"./setup-payment-reward.svg": 691967,
	"./sync-product-one-reward.svg": 933379,
	"./sync-product-ten-reward.svg": 886644,
	"./thank-you-2020-bronze.svg": 788615,
	"./thank-you-2020-diamond.svg": 826593,
	"./thank-you-2020-gold.svg": 894497,
	"./thank-you-2020-silver.svg": 519736,
	"./thank-you-2023-bronze.svg": 724370,
	"./thank-you-2023-diamond.svg": 938238,
	"./thank-you-2023-gold.svg": 329916,
	"./thank-you-2023-silver.svg": 895769,
	"./thank-you-2024-bronze.svg": 495835,
	"./thank-you-2024-diamond.svg": 89437,
	"./thank-you-2024-gold.svg": 248413,
	"./thank-you-2024-silver.svg": 479532,
	"./thank-you-2025-bronze.svg": 322612,
	"./thank-you-2025-diamond.svg": 752960,
	"./thank-you-2025-gold.svg": 113178,
	"./thank-you-2025-silver.svg": 136659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783171;